//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    listItem: {
      type: Object,
      default: {}
    },
    index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    doListItemClick() {
      this.$emit("on-click", this.listItem)
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/components/BaseNoticeItem.vue